import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { Showcase } from '../components/Showcase';
import { ProjectScene } from '../components/ProjectScene';
import { projects, site } from '../data/site';
import { Logo } from '../components/Logo';

const featured = projects.filter((p) => p.featured);

const Home: React.FC = () => {
  return (
    <>
      <section className="hero">
        <div className="wrap hero-grid">
          <div>
            <p className="hero-kicker">
              <i /> {site.availability}
            </p>
            <div className="hero-logo" aria-hidden="true">
              <Logo withName={false} markSize={52} />
            </div>
            <h1>
              Mustafa
              <br />
              <em>Gürses</em>
            </h1>
            <p className="hero-role">Yazılımcı · Full Stack Developer · Gaziantep</p>
            <p className="hero-lead">
              Mustafa Gürses (Mustafa Gurses) — ERP, B2B, e-ticaret ve yayınlı mobil uygulamalar.
              Panel, API, veri ve mağaza aynı elde.
            </p>
            <div className="hero-actions">
              <Link to="/projects" className="btn btn-fill">
                Projelere bak
              </Link>
              <Link to="/contact" className="btn btn-ghost">
                İş konuşalım
              </Link>
            </div>
          </div>
          <div className="hero-stage" aria-hidden="true">
            <div className="hero-float f1">
              <ProjectScene project={featured[0]} compact />
            </div>
            <div className="hero-float f2">
              <ProjectScene project={featured[1]} compact />
            </div>
          </div>
        </div>
      </section>

      <section className="identity" aria-labelledby="identity-title">
        <div className="wrap">
          <p className="eyebrow">Profil</p>
          <h2 id="identity-title">Mustafa Gürses, yazılımcı</h2>
          <p>
            Mustafa Gürses (Mustafa Gurses), Gaziantep’te yaşayan full stack yazılımcıdır. CEM
            Teknoloji bünyesinde Eruslu Global başta olmak üzere büyük ölçekli şirketler için ERP,
            MRP, B2B ve mobil uygulamalar geliştirir. Play Store ve App Store’da yayınlı ürünleri
            vardır.
          </p>
        </div>
      </section>

      <div className="wrap">
        <div className="section-title">
          <p className="eyebrow">Seçilmiş işler</p>
          <h2>Üretimde duran ürünler.</h2>
        </div>
        {featured.map((project, i) => (
          <Reveal key={project.id}>
            <Showcase project={project} flip={i % 2 === 1} />
          </Reveal>
        ))}
      </div>

      <section className="cta-band">
        <div className="wrap">
          <p className="eyebrow">Sıradaki</p>
          <h2>Benzer ölçekte bir iş mi var?</h2>
          <p>
            Stok, bayi, İK veya vitrin. Kapsamı birlikte netleştiririz; slayt değil çalışan sistem teslim ederim.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn btn-fill">
              İletişime geç
            </Link>
            <Link to="/about" className="btn btn-ghost">
              Beni tanı
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
